import { render, staticRenderFns } from "./EndButton.vue?vue&type=template&id=4b68d1ba&scoped=true"
import script from "./EndButton.vue?vue&type=script&lang=js"
export * from "./EndButton.vue?vue&type=script&lang=js"
import style0 from "./EndButton.vue?vue&type=style&index=0&id=4b68d1ba&prod&lang=sass&scoped=true"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "4b68d1ba",
  null
  
)

export default component.exports